"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toDate = exports.formatISODate = void 0;
var toDate = exports.toDate = function toDate(date) {
  if (date instanceof Date) {
    return date;
  }
  return new Date(date);
};
var formatISODate = exports.formatISODate = function formatISODate(date, showTime) {
  var _date$substring, _date, _date2;
  if (date instanceof Date) {
    date = date.toISOString();
  }
  // yyyy-mm-dd from ISO
  return "".concat((_date$substring = (_date = date) === null || _date === void 0 ? void 0 : _date.substring(0, 10)) !== null && _date$substring !== void 0 ? _date$substring : "", " ").concat(showTime && ((_date2 = date) === null || _date2 === void 0 ? void 0 : _date2.substring(11, 16)) || "").trim(); // ?? "";
};